import { render } from "./phone-page.vue?vue&type=template&id=28dd777e"
import script from "./phone-page.vue?vue&type=script&lang=js"
export * from "./phone-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__